module.exports = __webpack_public_path__ + "media/images/calendar2-minus-0c1af6fe52104e2ae4231d61b8b02789.png";